import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from "lodash";
import { Request } from "./request";
import { URLS } from "../constants/url.constants";
import { map } from "rxjs/operators";
import { HttpClient, HttpHeaders, HttpRequest } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class PatientService {
  constructor(
    private request: Request,
    private http: HttpClient,
  ) {
  }

  getPatientsList(event): Observable<any> {


    if (event.direction == 'desc') {
      event.direction = 2;
    }
    else {
      event.direction = 1;
    }

    let url = URLS.patient.getPatientsList + '?limit=' + event.pageSize + '&page=' + (event.pageIndex + 1) + '&searchkey=' + event.filterValue + '&order_by=' + event.active + '&dir=' + event.direction + '&type=' + event.type + '&from=' + event.fromdate + '&to=' + event.todate;

    if (event?.participant_id) {
      url = url + '&participant_id=' + event.participant_id;
    }
    if (event?.parent_type) {
      url = url + '&parent_type=' + event.parent_type;
    }
    if (event?.selectedHsc_id) {
      url = url + '&selectedHsc_id=' + event.selectedHsc_id;
    }
    if (event?.is_red_status) {
      url = url + '&is_red_status=' + event.is_red_status;
    }
    if (event?.user_id) {
      url = url + '&user_id=' + event.user_id;
    }

    return this.request.getApi(url);
  }


  getPatientsFirst(event): Observable<any> {


    if (event.direction == 'desc') {
      event.direction = 2;
    }
    else {
      event.direction = 1;
    }

    let url = URLS.patient.getPatientsFirst + '?dir=' + event.direction;

    if (event?.user_id) {
      url = url + '&user_id=' + event.user_id;
    }

    return this.request.getApi(url);
  }

  getAllPatientsList(): Observable<any> {

    let url = URLS.patient.getPatientsFullList;
    return this.request.getApi(url);
  }

  getAutoCompletePatientsList(val): Observable<any> {

    let url = URLS.patient.getPatientsFullList + '?searchkey=' + val + '&status=active';
    return this.request.getApi(url);
  }


  getAutoCompletePatientsListByField(fname, lname): Observable<any> {

    let url = URLS.patient.getPatientsFullList + '?searchfn=' + fname + '&searchln=' + lname;
    return this.request.getApi(url);
  }

  savePatients(values): Observable<any> {
    let url = URLS.patient.savePatients;
    return this.request.postApi(url, values);
  }

  editPatients(id, values): Observable<any> {
    let url = URLS.patient.editDeletePatients;
    url = _.replace(url, "{id}", id);
    return this.request.putApi(url, values);
  }

  patchPatients(id, values): Observable<any> {
    let url = URLS.patient.editDeletePatients;
    url = _.replace(url, "{id}", id);
    return this.request.patchApi(url, values);
  }

  deletePatients(data): Observable<any> {
    let url = URLS.patient.editDeletePatients;
    url = _.replace(url, "{id}", data.id);
    return this.request.deleteApi(url);
  }

  getPatientsInfo(id): Observable<any> {
    let url = URLS.patient.editDeletePatients;
    url = _.replace(url, "{id}", id);
    return this.request.getApi(url);
  }
}
